export const discounts = {
  WELCOME10: { percentOff: 10 },
  SAVE20: { percentOff: 20 },
}

export function applyDiscount(code, subtotal) {
  const discount = discounts[code]
  return subtotal - (subtotal * discount.percentOff) / 100
}
